import React from 'react';
import { twMerge } from 'tailwind-merge';
import { NewIconProps } from '@diritto/common/style/icon';

interface ListViewIconProps extends NewIconProps {
  color?: string;
}

export const ListViewIcon = ({ className, color = '#32383F' }: ListViewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_2732_65680" fill="white">
      <rect x="4" y="4" width="12" height="12" rx="0.6" />
    </mask>
    <rect
      x="4"
      y="4"
      width="12"
      height="12"
      rx="0.6"
      stroke={color}
      strokeWidth="2.18182"
      mask="url(#path-1-inside-1_2732_65680)"
    />
    <path d="M7.27246 7.59961H12.727" stroke={color} strokeWidth="1.09091" strokeLinecap="round" />
    <path d="M7.27246 10H12.727" stroke={color} strokeWidth="1.09091" strokeLinecap="round" />
    <path d="M7.27246 12.4004H12.727" stroke={color} strokeWidth="1.09091" strokeLinecap="round" />
  </svg>
);
